import { AppSettings } from "./app-settings";

export const loaderExemptedUrls: Array<string> = [
    AppSettings.apiUrl + "messages/unread_count"
];